import React from 'react'
import styled from 'styled-components'

const Headline = ({ children }) => {
  return <Wrapper className="headline">{children}</Wrapper>
}

const Wrapper = styled.h1`
  --font-size-headline: var(--font-size-8);
  --font-lineheight-headline: 90%;
  --font-weight-headline: var(--font-weight-7);

  font-family: var(--font-display);
  font-size: var(--font-size-headline);
  font-weight: var(--font-weight-headline);
  line-height: var(--font-lineheight-headline);
  text-transform: uppercase;
  color: var(--color-light);

  @media (min-width: 480px) {
    --font-size-headline: var(--font-size-9);
  }

  @media (min-width: 768px) {
    --font-size-headline: var(--font-size-10);
    --font-lineheight-headline: 85%;
  }

  @media (min-width: 1024px) {
    --font-size-headline: var(--font-size-12);
    --font-lineheight-headline: 80%;
  }

  .year & {
    @media (min-width: 480px) {
      --font-size-headline: var(--font-size-9);
    }

    @media (min-width: 768px) {
      --font-size-headline: var(--font-size-10);
      --font-lineheight-headline: 85%;
    }

    @media (min-width: 1024px) {
      --font-size-headline: 19.2rem;
      --font-lineheight-headline: 80%;
    }
  }
`

export default Headline
